export default {"src":"/_next/static/media/BM-Logo-black.db84495d.svg","height":37,"width":39};